import { render } from "./IntroComponent.vue?vue&type=template&id=79422855&scoped=true"
const script = {}

import "./IntroComponent.vue?vue&type=style&index=0&id=79422855&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79422855"]])

export default __exports__